@if (!selectedProcedure) {
  <div>
    <div class="bold-text pb-2">
      <strong class="payment-title">Moyen de paiement actuel :</strong>
      <span class="prixtel-color">
        @if (selectedMethod && selectedMethod == 'rib') {
          <span>Prélèvement automatique sur votre compte.</span>
        }
        @if (selectedMethod && ['rib', 'cheque'].indexOf(selectedMethod) == -1) {
          <span>Prélèvement automatique sur votre carte bancaire.</span>
        }
        @if (selectedMethod && selectedMethod == 'cheque') {
          <span>Par chèque, carte bancaire ou virement.</span>
        }
      </span>
    </div>
    <br />
    <div class="cards-grid">
        @for (card of cards; let index = $index; track index) {
        <div>
          @if (customer.iban && index == 0) {
            <div class="item">
              <div class="card text-center {{ selectedMethod && selectedMethod == 'rib' ? 'active' : '' }}">
                <div class="card-header" [ngClass]="{'not-selected-card-header': selectedMethod && (selectedMethod.includes('pm_') || selectedMethod.includes('card_')), 'selected-card-header': selectedMethod == 'rib'}">Par IBAN</div>
                <div class="card-body-centered">
                  <div class="bold-label-text pt-2">IBAN</div>
                  <div>{{ customer.iban }}</div>
                </div>
                <div class="icon-tools">
                  <button type="button" class="cta_btn level_2 payment" (click)="goToUpdatePage('rib')">Modifier<span></span></button>
                  @if (supportUser) {
                    <button id="delete_1" type="button" class="cta_btn level_2" (click)="deleteIban()">Supprimer</button>
                  }
                </div>
                <div class="cta-grid">
                  <input id="radio_{{ index }}" class="radio-medium" type="radio" name="method" [(ngModel)]="selectedMethod" value="rib" (click)="updateMethod('rib')"/>
                </div>
              </div>
            </div>
          }
          @if (!customer.iban && index == 0) {
            <div class="item">
              <div class="card text-center {{ selectedMethod && ['rib', 'cheque'].indexOf(selectedMethod) == -1 ? 'active' : '' }}">
                <div class="card-header not-selected-card-header">Par IBAN</div>
                <div class="card-body-centered">
                  <div class="bold-label-text pt-2">IBAN</div>
                  <div>Aucun IBAN enregistré</div>
                </div>
                <button type="button" class="cta_btn level_2" (click)="goToUpdatePage('rib')">Ajouter<span></span></button>
                @if (supportUser) {
                  <div class="card-body-centered"></div>
                }
                <div class="text-center w-100">&nbsp;</div>
              </div>
            </div>
          }
          @if (index !== 0 && index !== (cards.length - 1)) {
            <div class="item">
              <div class="card text-center {{ selectedMethod && ['rib', 'cheque'].indexOf(selectedMethod) == -1 ? 'active' : '' }}">
                <div class="card-header" [ngClass]="{'not-selected-card-header': selectedMethod !== card.externalId, 'selected-card-header': selectedMethod == card.externalId}">Par CB</div>
                  <div class="card-body-centered">
                    <div class="bold-label-text pt-2">{{ card.cardType }}</div>
                    <div>{{ card.cardNumber }}</div>
                    <div>Exp: {{ formattingExpiryDate(card.cardExpiryDate) }}</div>
                  </div>
                  @if (supportUser) {
                    <button type="button" id="delete_2" class="cta_btn level_2" (click)="deleteCard(card.externalId)">Supprimer</button>
                  }
                  <div class="cta-grid">
                    <input id="radio_{{ index }}" class="radio-medium" type="radio" name="method" [(ngModel)]="selectedMethod" value="{{card.externalId}}" (click)="updateMethod(card.externalId)"/>
                  </div>
              </div>
            </div>
          }
          @if (displayCBCard && index == (cards.length -1) && inProgressCardCreation == false) {
            <div class="item">
                <button id="add-cb" type="button" class="cta_btn level_2" (click)="goToUpdatePage('cb')">Ajouter une CB<span></span></button>
            </div>
          }
        </div>
      }
    </div>
    @if (sepa) {
      <div>
        <a (click)="downloadSepa()" class="pointer-cursor">
          <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Mandat SEPA
        </a>
      </div>
    }
  </div>
}
